<button
	#button
	matRipple
	class="Button Button--{{ color() }}"
	[matTooltip]="tooltipLabel()"
	[matTooltipPosition]="tooltipPosition()"
	matTooltipClass="Tooltip"
	[disabled]="disabledInner() || isDisabled()"
	[class.Button--isDisabled]="isDisabled()"
	[class.Button--isFull]="isFull()"
	[class.Button--hasIcon]="hasIcon()"
	[class.Button--isOutline]="isOutline()"
	[class.Button--small]="buttonSmall()"
>
	<ng-content select="appIcon" />
	<ng-content />
	@if (isLoading() || loading()) {
		<section class="Spinner-overlay">
			<mat-spinner matPrefix color="primary" [diameter]="30"></mat-spinner>
		</section>
	}
</button>
